import { useTranslation } from '@framework/i18n';
import { ItaliaButton } from '../components/ItaliaButton';
import { getIdpAuthUrl } from '../hooks/useGetIdpAuthUrlFn';

export interface CieAccessButtonProps {
  resolvePublicUrl: (path: string) => string;
  fullWidth?: boolean;
}

/**
 * Pulsante CIE
 */
export function CieLoginButton(props: CieAccessButtonProps) {
  const { resolvePublicUrl, fullWidth } = props;
  const { t } = useTranslation();

  const redirectUrl = getIdpAuthUrl({ idpMethod: 'CIE', resolvePublicUrl });

  return (
    <ItaliaButton
      href={redirectUrl}
      style={fullWidth ? { width: '100%' } : undefined}
      image={require('./img/cie-icon.png')}
      text={t('user.login.cie-button', 'Entra con CIE')}
    />
  );
}
